export const NOW_VALUE = '$now';

export enum DateTimeValueType {
  Relative = 'Relative',
  Specific = 'Specific',
}
